import AuthPage from 'components/AuthPage';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <AuthPage>
      <h1 className='self-center bold text-grey800 font-[DKLiquidEmbrace] text-3xl pb-[24px] '>
        {t('common.pageNotFound')}
      </h1>
    </AuthPage>
  );
};

export default NotFound;
